<script setup lang="ts">
import { useCurrencyFormaterFromCents } from '@/composable/useCurrencyFormater'
import { useRateStore } from '@/store/rate'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { amountFare, getRateData, getFareData } = storeToRefs(useRateStore())

const totalConsumptionAndDemand = computed(() => {
  if (!getRateData.value?.energy_sensors_totalizers) {
    return { offPeakConsumption: 0, peakConsumption: 0, offPeakDemand: 0, peakDemand: 0 }
  }

  return getRateData.value.energy_sensors_totalizers.reduce(
    (acc, sensor) => {
      acc.offPeakConsumption += sensor.totalizer.consumption.off_peak_consumption_kwh || 0
      acc.peakConsumption += sensor.totalizer.consumption.peak_consumption_kwh || 0
      acc.offPeakDemand += sensor.totalizer.demand.off_peak_demand_kw || 0
      acc.peakDemand += sensor.totalizer.demand.peak_demand_kw || 0
      return acc
    },
    { offPeakConsumption: 0, peakConsumption: 0, offPeakDemand: 0, peakDemand: 0 },
  )
})

const groupValue =
  totalConsumptionAndDemand.value?.offPeakConsumption * getFareData.value.off_peak_consumption?.price_per_unit +
  totalConsumptionAndDemand.value?.peakConsumption * getFareData.value.peak_consumption?.price_per_unit +
  totalConsumptionAndDemand.value?.offPeakDemand * getFareData.value.measured_off_peak_demand?.price_per_unit +
  totalConsumptionAndDemand.value?.peakDemand * getFareData.value.measured_peak_demand?.price_per_unit
</script>

<template>
  <div class="flex gap-6 text-center font-medium text-black">
    <div class="flex w-full flex-col bg-white p-4 shadow-md">
      <header>
        <span>Percentual da linha de extrusão</span>
      </header>
      <div class="flex flex-1 items-center justify-center">
        <span>{{ Math.round((groupValue / amountFare) * 100 * 10) / 10 }}%</span>
      </div>
    </div>
    <div class="flex w-full flex-col bg-white p-4 shadow-md">
      <header>
        <span>Valor financeiro da tabela</span>
      </header>
      <div class="flex flex-1 items-center justify-center">
        <span>{{ useCurrencyFormaterFromCents(amountFare) }}</span>
      </div>
    </div>
    <div class="flex w-full flex-col bg-white p-4 shadow-md">
      <header>
        <span>Valor financeiro do grupo</span>
      </header>
      <div class="flex flex-1 items-center justify-center">
        <span>{{ useCurrencyFormaterFromCents(groupValue) }}</span>
      </div>
    </div>
  </div>
</template>
